import { render, staticRenderFns } from "./tenant-branding-colors.vue?vue&type=template&id=f90fecf4&"
import script from "./tenant-branding-colors.vue?vue&type=script&lang=js&"
export * from "./tenant-branding-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports